/**
 * 38 provinsi Indonesia, ejaan kanonik.
 *
 * Dipakai dropdown provinsi di form alamat kirim. Daftar ini HARUS sama
 * persis dengan `PROVINCES` di `backend/app/services/ongkir.py`, karena
 * di sanalah tiap provinsi dipetakan ke zona ongkir. Provinsi yang bisa
 * dipilih di sini tapi tidak ada di sana berarti pembeli memilihnya lalu
 * checkout gagal 422 tanpa jalan keluar.
 *
 * Yang menjaga: `backend/tests/test_ongkir.py`
 * (test_frontend_dropdown_matches_backend_province_list) membaca berkas
 * ini dan membandingkannya baris per baris. Jadi jangan tambahkan string
 * berkutip tunggal lain di berkas ini — hanya nama provinsi.
 *
 * Urutannya sengaja geografis (Sumatera, Jawa, Bali/Nusa, Kalimantan,
 * Sulawesi, Maluku, Papua), bukan alfabetis: orang mencari provinsinya
 * lewat pulau, dan sebagian besar pembeli berhenti di rombongan Jawa.
 */
export const PROVINCES = [
  'Aceh',
  'Sumatera Utara',
  'Sumatera Barat',
  'Riau',
  'Kepulauan Riau',
  'Jambi',
  'Sumatera Selatan',
  'Kepulauan Bangka Belitung',
  'Bengkulu',
  'Lampung',
  'DKI Jakarta',
  'Jawa Barat',
  'Banten',
  'Jawa Tengah',
  'DI Yogyakarta',
  'Jawa Timur',
  'Bali',
  'Nusa Tenggara Barat',
  'Nusa Tenggara Timur',
  'Kalimantan Barat',
  'Kalimantan Tengah',
  'Kalimantan Selatan',
  'Kalimantan Timur',
  'Kalimantan Utara',
  'Sulawesi Utara',
  'Gorontalo',
  'Sulawesi Tengah',
  'Sulawesi Barat',
  'Sulawesi Selatan',
  'Sulawesi Tenggara',
  'Maluku',
  'Maluku Utara',
  'Papua Barat',
  'Papua Barat Daya',
  'Papua',
  'Papua Selatan',
  'Papua Tengah',
  'Papua Pegunungan',
] as const;

export type Province = (typeof PROVINCES)[number];
